import { gsap } from "gsap/dist/gsap";

export default function popUpFadeInRotate(
  images,
  imagesTl,
  containerImageRef,
  rotationTl,
  optionsAnimImages
) {
  rotationTl
    .to(
      containerImageRef.current,
      {
        rotate: 360 * optionsAnimImages.rotationOptions.turnQty,
        duration: 60 * optionsAnimImages.rotationOptions.minute,
        repeat: -1,
      },
      "same-time"
    )
    .to(
      images,
      {
        rotate: -360 * optionsAnimImages.rotationOptions.turnQty,
        duration: 60 * optionsAnimImages.rotationOptions.minute,
        repeat: -1,
      },
      "same-time"
    );

  images.forEach((el, i) => {
    if (i === 0) {
      const animation = gsap.from(el, {
        scale: 0,
        opacity: 0,
        onComplete: () => rotationTl.play(),
      });

      imagesTl.add(animation);
    }

    if (i > 0) {
      const animation = gsap.from(
        el,
        {
          opacity: 0,
          duration: 0.3,
        },
        `-=5`
      );

      imagesTl.add(animation);
    }
  });
}
